
export class PigGenderViewModel {
  constructor(
    readonly id: number,
    readonly name: string) {
  }

  toString(): string {
    return `Id: ${this.id}, Name: ${this.name}`;
  }
}